type Link = {
  name: string;
  url: string;
};

const links: Link[] = [
  {
    name: 'Source',
    url: 'https://git-ce.rwth-aachen.de/wzl-mq-ms/forschung-lehre/virtuelles-bildverarbeitungslabor/user-interface',
  },
];

export default links;
